<template>
  <div
    class="page"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.8)"
  >
    <el-container>
      <el-header>
        <div class="even-box">
          <div v-if="step>1" @click="back" class="icon-box"><i class="el-icon-back back-icon"></i><span>返回</span></div>
          <div class="title">网安联认证中心认证证书查询</div>
        </div>
      </el-header>
      <el-main>
        <div class="card-box" v-if="step===1">
          <el-form label-position="left" label-width="110px" :model="form">
            <el-form-item label="证书编号：">
              <el-input v-model="form.certificateNo" placeholder="请输入证书编号"></el-input>
            </el-form-item>
            <el-form-item label="获证组织名称：">
              <el-input v-model="form.organizationName" placeholder="请输入获证组织名称"></el-input>
            </el-form-item>
            <div class="tips">注：输入获证组织名称或证书编号即可查询</div>
            <div class="flex-center-box">
              <el-button :disabled="!form.certificateNo&&!form.organizationName" type="primary" @click="submitForm" icon="el-icon-search">证书查询</el-button>
            </div>
          </el-form>
        </div>
        <div class="table-box" v-if="step===2">
          <el-table
            :data="tableData"
            border
            style="width: 100%">
            <el-table-column label="序号" type="index" width="50" />
            <el-table-column prop="certificateNo" label="证书编号" min-width="120" />
            <el-table-column prop="certificateName" label="证书名称" min-width="120" />
            <el-table-column prop="organizationName" label="获证组织名称" min-width="120" />
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button @click="handleClick(scope.row.id)" type="text" size="small">查看详情</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="table-box" v-if="step===3">
          <el-descriptions class="margin-top" title="" :column="1" border>
            <el-descriptions-item label="证书名称">
              {{ detailObj.certificateName || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="证书编号">
              {{ detailObj.certificateNo || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="证书状态">
              {{ statusOptions[detailObj.certificateStatus] || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="认证项目">
              {{ detailObj.certificationProject || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="认证依据">
              {{ detailObj.certificationBasis || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="证书使用的认可标识">
              {{ detailObj.certificateRecognitionMark || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="认证覆盖的业务范围">
              {{ detailObj.businessScope || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="认证覆盖人数">
              {{ detailObj.certifiedPeopleNumber || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="获证组织">
              {{ detailObj.organizationName || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="统一社会信用代码">
              {{ detailObj.unifiedSocialCreditCode || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="注册地址">
              {{ detailObj.registrationAddress || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="认证地址">
              {{ detailObj.officeAddress || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="发证日期">
              {{ detailObj.issuanceDateStr || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="初次获证日期">
              {{ detailObj.initialCertificationDateStr || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="换证日期">
              {{ detailObj.renewalDateStr || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="证书有效期">
              {{ detailObj.validityDateStr || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="证书状态变化原因">
              {{ detailObj.changeReason || '' }}
            </el-descriptions-item>
            <el-descriptions-item label="备注">
              {{ detailObj.remarks || '' }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import apiInstance from '@/utils/request'
export default {
  name: 'Home',
  components: {},
  data() {
    return {
      // 证书状态：0-过期失效，1-有效, 2-注销，3-撤销，4暂停 此处顺序不能变
      statusOptions: ['过期失效','有效', '注销', '撤销', '暂停'],
      loading: false,
      step: 1,
      form: {
        certificateNo: '',
        organizationName: ''
      },
      tableData: [],
      detailObj: {
        certificateName: '', // 证书名称
        certificateNo: "", // 证书编号
        certificateStatus: undefined, // 证书状态
        certificationProject: '', // 认证项目
        certificationBasis: '', // 认证依据
        businessScope: '', // 认证覆盖的业务范围
        organizationName: '', // 获证组织
        unifiedSocialCreditCode: '', // 统一社会信用代码
        registrationAddress: '', // 注册地址
        officeAddress: '', // 办公地址
        issuanceDateStr: '', // 发证日期
        initialCertificationDateStr: '', // 初次获证日期
        renewalDateStr: '', // 换证日期
        validityDateStr: '', // 证书有效期
        changeReason: '', // 证书状态变化原因
        remarks: '', // 备注
      },
    };
  },
  created() {
  },
  mounted() {
  },
	updated() {
  },
  beforeUnmount() {
  },
  filters: {
  },
  methods: {
    submitForm() {
      this.loading = true;
      console.log("this.form", this.form);
      apiInstance.post(`/organization/certificate/mini/list`, this.form).then(res => {
        let { data } = res;
        this.tableData = data.data;
        this.step = 2;
        this.loading = false;
      }).catch( error => {
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    handleClick(id) {
      if (!id) return;
      console.log("id", id);
      this.loading = true;
      console.log("this.form", this.form);
      apiInstance.get(`/organization/certificate/mini/getInfo?id=${id}`, {}).then(res => {
        let { data } = res;
        this.detailObj = data.data;
        this.step = 3;
        this.loading = false;
      }).catch( error => {
        this.loading = false;
        this.$message.error('出错了，请联系工作人员！');
      });
    },
    back() {
      if (this.step <= 1) return;
      this.step = this.step-1;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.even-box {
  display: flex;
  align-items: center;
  font-size: 18px;
}
.icon-box:active {
  color: gray;
}
.back-icon {
  margin-right: 6px;
}
.title {
  flex: 1;
  padding: 30px 10px;
  text-align: center;
  font-weight: 600;
}
.card-box {
  /* margin: 30px auto; */
  padding: 30px 10px;
  box-shadow: 0 6px 24px 0 rgba(0,0,0,.12);
}
.tips {
  color: red;
  padding: 0px 0px 30px;
  font-size: 14px;
}
.table-box {
  margin-bottom: 30px;
}

/* 公共样式 */
.flex-center-box {
  display: flex;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue